import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient } from '@angular/common/http';
import { ApiService } from './services/api.service';
import { checkIfUserIsAuthenticated } from './services/check-login-initializer';
import { Interceptor401Service } from './interceptors/interceptor401.service';
import { AccountService } from './services/account.service';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), provideClientHydration(), provideHttpClient(),
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor401Service, multi: true },
    /* { provide: APP_INITIALIZER, useFactory: checkIfUserIsAuthenticated, multi: true, deps: [AccountService]}  */
  ]
};
